var path = 'src/app/forms/fields/checkbox-field.html';
var html = "<div class=checkbox ng-class=\"disabled?'disabled':''\"> <label> <input ng-checked=checked ng-disabled=disabled frm-model ng-model=model frm-required ng-required=required() type=checkbox /> <span ng-transclude></span> </label> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/checkbox-field.html
 ** module id = 251
 ** module chunks = 0
 **/